import axios from 'axios';
import {getUserPool} from './cognito';
import {CognitoIdToken, CognitoAccessToken, CognitoRefreshToken, CognitoUser, CognitoUserSession} from 'amazon-cognito-identity-js';
import {IDENTITY_API} from 'utils/backend/server/api_library';

const initiateMagicLinkAuth = async (userEmail) => {
  const body = {email: userEmail};
  const url = `${IDENTITY_API}/auth/magic_auth`;
  const result = await axios.post(url, body);
  return result.data;
};

const validateMagicLinkAuth = async (token) => {
  const body = {token};
  const url = `${IDENTITY_API}/auth/magic_auth/validation`;
  const result = await axios.post(url, body);
  return result.data;
};

const sendMagicLink = async (email) => {
  const result = await initiateMagicLinkAuth(email);
  return result;
};

const loginWithToken = async (token) => {
  // call backend
  const result = await validateMagicLinkAuth(token);
  const {username, idToken, accessToken, refreshToken} = result;

  // save
  const userPool = getUserPool();
  const cognitoIdToken = new CognitoIdToken({IdToken: idToken});
  const cognitoAccessToken = new CognitoAccessToken({AccessToken: accessToken});
  const cognitoRefreshToken = new CognitoRefreshToken({RefreshToken: refreshToken});

  const userSession = new CognitoUserSession({
    IdToken: cognitoIdToken,
    AccessToken: cognitoAccessToken,
    RefreshToken: cognitoRefreshToken,
  });

  const user = new CognitoUser({
    Username: username,
    Pool: userPool,
  });

  user.setSignInUserSession(userSession);
};

export {
  sendMagicLink,
  loginWithToken,
};
